/** Nombre de positions retenues et allouées pour chaque sillage. */
export const TRAIL_LENGTH = 900;

export interface TrailPoint {
  readonly x: number;
  readonly y: number;
}

/**
 * Historique borné des positions affichées.
 *
 * La politique de rétention appartient au monde visible, pas au tampon WebGL :
 * le renderer alloue simplement la capacité que cette classe annonce.
 */
export class TrailHistory {
  readonly #points = new Map<string, TrailPoint[]>();

  record(id: string, point: TrailPoint): void {
    const points = this.#points.get(id) ?? [];
    points.push(point);
    if (points.length > TRAIL_LENGTH) points.shift();
    this.#points.set(id, points);
  }

  pointsFor(id: string): readonly TrailPoint[] {
    return this.#points.get(id) ?? [];
  }

  retain(ids: ReadonlySet<string>): void {
    for (const id of this.#points.keys()) {
      if (!ids.has(id)) this.#points.delete(id);
    }
  }

  clear(): void {
    this.#points.clear();
  }
}
